<!--おしらせ-->
<template>
  <v-main>
    <v-container class="mx-auto" style="max-width: 1100px; font-size: 1.25rem;">
      <div class="text-h4 mb-8">{{ welfareById(id).title }}</div>
      <div class="text-body-1 mb-4">更新日時：{{ welfareById(id).contributedAt }}</div>
      <div class="text-body-1 mb-8">更新者：{{ welfareById(id).contributor }}</div>
      <v-divider class="mb-8"/>
      <vue-markdown
          v-if="welfareById(id)"
          :postrender="postRenderMarkdown"
      >{{ welfareById(id).body }}
      </vue-markdown>
      <v-col class="text-center">
        <router-link :to="{ name: 'welfareList' }" style="font-size: 1rem;">一覧へ戻る</router-link>
      </v-col>
    </v-container>
  </v-main>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import { Logger } from 'aws-amplify';
import { mapActions, mapGetters } from 'vuex';

const logger = new Logger('welfare');

export default {
  name: 'Welfare',
  components: {
    'vue-markdown': VueMarkdown,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  async created() {
    logger.info('created');
    await this.getWelfareBy({ id: this.id });
  },

  data() {
    return {};
  },

  methods: {
    /**
     * vue-markdownの描画後処理
     * @param html
     * @returns {*}
     */
    postRenderMarkdown(html) {
      logger.info('postRenderMarkdown');
      // リンクを別タブで開くように置換する
      return html.replace(/<a/g, '<a target="_blank"');
    },

    ...mapActions(['getWelfareBy']),
  },

  computed: {
    ...mapGetters(['welfareById']),
  },
};
</script>

<style scoped lang="scss">

</style>